import commentsDefaultUserImage from "assets/comments-default-user.png";
import {Tooltip} from "components/tooltip/Tooltip";
import UserProfileTooltip from "components/tooltip/UserProfileTooltip.component";
import {UserProfileProps} from "types/userDTO";
import { SHARED_TOOLTIP_ID } from "components/tooltip/AppTooltip.component";

export function UserProfile(props: UserProfileProps) {
    const profilePictureBaseUrl = typeof window.ENVIRONMENT !== "undefined" && window.ENVIRONMENT.PROFILE_PICTURE_BASE_URL;
    const profilePicture = props.user.connectUserId ? `${profilePictureBaseUrl}${props.user.connectUserId}?type=initials` : commentsDefaultUserImage;
    const tooltipId = `${props.user.idUser}-approvers-row-tooltip-${props.uniqueKey}`;

    const setFallbackImage = function (event: any) {
        event.target.src = "https://static-odp.visma.net/commoncomponents/vismaSkin/images/services/default/medium.png";
    };

    return (
        <div className="d-flex align-items-center cursor-pointer" data-testid={tooltipId} data-for={SHARED_TOOLTIP_ID} data-tip={tooltipId}>
                <div>
                    <div className={"ga-avatar mr-8"}>
                        <img src={profilePicture}
                             alt="user profile avatar"
                             onError={(event) => {
                                 setFallbackImage(event);
                             }}
                        />
                    </div>
                </div>
                <div>{props.user.fullName}</div>

            <Tooltip
                id={tooltipId}
                content={() => <UserProfileTooltip user={props.user}/>}
            />
        </div>
    );
}

export default UserProfile;